import React, { useEffect, useState } from 'react';
import Tooltip from "@mui/material/Tooltip";
import VisitorFormGroup from "./VisitorFormGroup";
import CollapsibleVisitorSummary from "../../../Visitors/BookingForm/Forms/Sections/CollapsibleVisitorSummary";

const VisitorList = (props) => {

    function findErrors(errorObject, id) {
        const errors = {};
        for (const key in errorObject) {
            if (key.startsWith(`visitors[${id}].`)) {
                const field = key.slice(`visitors[${id}].`.length);
                errors[field] = errorObject[key];
            }
        }
        return errors;
    }

    return (<>
        <div>
            { props.visitors.map((visitor, index) => (
                <CollapsibleVisitorSummary
                    key={index}
                    index={index}
                    visitor={visitor}
                    onDelete={() => props.onDelete(index)}
                    hideButtons={(props.visitors.length === 1)}
                    preventCollapse={(props.visitors.length === 1)}
                    onCollapse={(index, isCollapsed) => props.onUpdate('_isCollapsed', isCollapsed, index)}
                    className="top-divider"
                >
                    <VisitorFormGroup
                        key={index}
                        index={index}
                        visitor={visitor}
                        errors={findErrors(props.errors, index)}
                        onUpdate={props.onUpdate}
                    />
                </CollapsibleVisitorSummary>
            ))}
        </div>

        <div className="grid-x grid-margin-x">
            <div className="cell small-12 text-right">
                <Tooltip title="Add another visitor">
                    <button
                        type="button"
                        className="button small secondary width-1"
                        onClick={(e) => {
                            e.preventDefault();
                            props.onAdd();
                        }}
                    >
                        <i className="fa fa-plus"></i>&nbsp;
                        Visitor
                    </button>
                </Tooltip>
            </div>
        </div>
    </>);
}

VisitorList.propTypes = {
   
}

VisitorList.defaultProps = {
    
}

export default VisitorList;
